module.exports = __webpack_public_path__ + "img/card-b.7aeaedb3.png";